module.exports = __webpack_public_path__ + "img/anita-besar.e4d3265a.png";